import React, { useState, useEffect } from 'react';
import { makeStyles, lighten } from '@material-ui/core/styles';
import { CurrencyField, NumberFormat, TextField } from '@roc/ui';
import { Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: '100px',
  },
  noteTime: {
    display: 'block',
    textAlign: 'left',
    color: lighten(theme.palette.text.primary, 0.3)
  }
}));

export const PayoffReconciliationReviewRequest = ({ record }) => {
  const classes = useStyles();
  const [requestDetails, setRequestDetails] = useState(record || {});
  const [comments, setComments] = useState(record?.comments || '');

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CurrencyField
          required
          variant="outlined"
          label="Amount to Waive"
          testId="amountToWaive"
          value={record?.requestedAmount}
          onChange={(name, value) =>
            record.requestedAmount = value
          }
          standaloneLabel
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          standaloneLabel
          testId="comments"
          required
          variant="outlined"
          label="Comments"
          value={comments}
          multiline
          minRows={2}
          onChange={e => {
           setComments(e.target.value);
           record.comments = e.target.value;
          }}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
